module.exports = __webpack_public_path__ + "static/media/js.002ff05f.png";